import React, { Component } from 'react';
import { Steps, Icon } from 'antd';
import { throttle } from 'lodash';
import classNames from 'classnames';
import styles from './index.less';

const { Step } = Steps;

const stepsWidthDivider = 1024;

export default class StepsBlock extends Component {
  constructor(...args) {
    super(...args);
    this.handleWindowResize = throttle(this.handleWindowResize, 100);
    this.state = {
      windowWidth: window.innerWidth
    };
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleWindowResize);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
  }
  handleWindowResize = () => {
    this.setState({
      windowWidth: window.innerWidth
    });
  }
  render() {
    const { currentStep } = this.props;
    const { windowWidth } = this.state;
    const isMobile = windowWidth <= stepsWidthDivider;
    return (
      <Steps
        current={currentStep}
        direction={isMobile ? 'vertical' : 'horizontal'}
        progressDot={(iconDot, { index, status }) => {
          if (status === 'wait') {
            return <div className={classNames(styles.iconWrapper, styles.wait)}>{index + 1}</div>;
          }
          if (status === 'process') {
            return <div className={classNames(styles.iconWrapper, styles.process)}>{index + 1}</div>;
          }
          if (status === 'finish') {
            return <div className={classNames(styles.iconWrapper, styles.finish)}><Icon type="check" /></div>;
          }
        }}
      >
        <Step title="签署登记协议" />
        <Step title="填写业务联系人信息" />
        <Step title="填写公司基本信息" />
        <Step title="填写公司资质信息" />
        <Step title="填写公司经营信息" />
        <Step title="完成登记" />
      </Steps>
    );
  }
}
